// extracted by mini-css-extract-plugin
export default {"offline":"index_offline_zWZs5","offlineBox":"index_offlineBox_GosNk","icon":"index_icon_3fdUp","btn":"index_btn_qXib-"};